// extracted by mini-css-extract-plugin
module.exports = {"organism__section-card-container":"styles_organism__section-card-container__KwWjf"};